export default "<p>\n    bid-history works!\n</p>\n";